/**
 * Sun365 — Tax Confirmation Modal v7
 *
 * Add-to-Cart  → intercept form[action*="/cart/add"] submit
 * Shop Pay / dynamic checkout → CSS pointer-events:none blocks iframe clicks,
 *   they bubble up to .dynamic-checkout which we handle here.
 *   After confirmation we add body.sun365-tax-ok (removes CSS block) then
 *   re-click the real button inside the container.
 */
(function () {
  'use strict';

  const SESSION_KEY = 'sun365_tax_confirmed';
  const BODY_CLASS  = 'sun365-tax-ok';

  // ── DOM ───────────────────────────────────────────────────────────────────
  const modal    = document.getElementById('tax-confirmation-modal');
  if (!modal) return;

  const btnOk     = document.getElementById('tax-modal-confirm');
  const btnCancel = document.getElementById('tax-modal-cancel');

  let pendingAction = null;

  // ── Open / close ──────────────────────────────────────────────────────────
  function openModal(action) {
    pendingAction = action;

    modal.style.display = '';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { modal.classList.add('tax-open'); });
    });
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('tax-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { modal.style.display = 'none'; }, 230);
    pendingAction = null;
  }

  // ── Cart attributes ───────────────────────────────────────────────────────
  function saveCartAttributes() {
    return fetch('/cart/update.js', {
      method : 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body   : JSON.stringify({
        attributes: {
          '0%-MwSt-Berechtigung §12 Abs.3': 'Bestätigt',
          'Bestätigt am': new Date().toISOString()
        }
      })
    });
  }

  // ── Mark session + unlock body class ─────────────────────────────────────
  function markConfirmed() {
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (_) {}
    document.body.classList.add(BODY_CLASS);
  }

  // ── Proceed after confirmation ────────────────────────────────────────────
  function proceedWithAction() {
    if (!pendingAction) return;
    var type   = pendingAction.type;
    var target = pendingAction.target;

    if (type === 'form') {
      target.dataset.taxConfirmed = '1';
      target.requestSubmit ? target.requestSubmit() : target.submit();

    } else if (type === 'dynamic') {
      // CSS block removed (body.sun365-tax-ok added in markConfirmed).
      // Now find and click the real payment button inside the container.
      setTimeout(function () {
        var btn =
          target.querySelector('.shopify-payment-button__button') ||
          target.querySelector('[data-shopify-buttoncontainer] button') ||
          target.querySelector('button:not([disabled])') ||
          target.querySelector('[role="button"]') ||
          target.querySelector('a');

        if (btn) {
          btn.click();
        } else {
          // Last resort: dispatch a click at the center of the container
          var rect = target.getBoundingClientRect();
          var el   = document.elementFromPoint(
            rect.left + rect.width  / 2,
            rect.top  + rect.height / 2
          );
          if (el && el !== target) el.click();
        }
      }, 80); // small delay lets CSS repaint (pointer-events restored)
    }
  }

  // ── Confirm ───────────────────────────────────────────────────────────────
  btnOk.addEventListener('click', function () {
    closeModal();
    markConfirmed();
    saveCartAttributes().catch(function () {}).finally(proceedWithAction);
  });

  btnCancel.addEventListener('click', closeModal);
  modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('tax-open')) closeModal();
  });

  // ── Already confirmed? ────────────────────────────────────────────────────
  function alreadyConfirmed(el) {
    if (el && el.dataset.taxConfirmed === '1') return true;
    try { return !!sessionStorage.getItem(SESSION_KEY); } catch (_) { return false; }
  }

  // If session already confirmed on page load, add body class immediately
  // so the CSS pointer-events block is not applied at all.
  if (alreadyConfirmed()) {
    document.body.classList.add(BODY_CLASS);
  }

  // ── 1. Cart form intercept ────────────────────────────────────────────────
  function wireCartForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form.dataset.taxWired) return;
      form.dataset.taxWired = '1';
      form.addEventListener('submit', function (e) {
        if (alreadyConfirmed(form)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        openModal({ type: 'form', target: form });
      }, true);
    });
  }

  // ── 2. Dynamic checkout intercept (.dynamic-checkout container) ───────────
  //
  // CSS already sets pointer-events:none on all children of .dynamic-checkout
  // (including iframes) so clicks bubble up to the container div itself.
  // We listen here in capture phase for maximum priority.
  //
  function wireDynamicCheckout() {
    document.querySelectorAll('.dynamic-checkout').forEach(function (container) {
      if (container.dataset.taxWired) return;
      container.dataset.taxWired = '1';

      container.addEventListener('click', function (e) {
        // If already confirmed (body has class), let click through normally
        if (document.body.classList.contains(BODY_CLASS)) return;
        if (alreadyConfirmed()) {
          markConfirmed();
          return;
        }
        e.preventDefault();
        e.stopImmediatePropagation();
        openModal({ type: 'dynamic', target: container });
      }, true);
    });
  }

  // ── Init + MutationObserver ───────────────────────────────────────────────
  function init() {
    wireCartForms();
    wireDynamicCheckout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.nodeType !== 1) continue;
        var hit =
          (n.matches && (n.matches('form[action*="/cart/add"]') || n.matches('.dynamic-checkout'))) ||
          (n.querySelector && (n.querySelector('form[action*="/cart/add"]') || n.querySelector('.dynamic-checkout')));
        if (hit) { init(); return; }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

})();
